export const UNAUTHORIZED = {
  code: 401,
  constant: 'UNAUTHORIZED',
};
export const CONFLICT = {
  code: 409,
  constant: 'CONFLICT',
};
